module.exports = __webpack_public_path__ + "img/img_concern.41964d94.png";